import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  navbar: "1-2",
  navbarHook: "mounted",
  loadMethods: ["loadSettings"],
});
